import React, { useState } from "react";
import Layout from "../../components/layouts/layout";
import "./style.scss";
import LPFooter from "../../components/LPFooter";
import BaskarImage from "../../assets/Images/newAboutUs/baskar.png";
import DataService from "../../services/api/data_services";
import { navigate } from "gatsby";
import { InlineWidget } from "react-calendly";

function DigitalMentalHealth() {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    organization: "",
    partnerType: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    DataService.postData(
      `admin/api/sendmail`,
      {
        firstName: formData.fullName.split(" ")[0] || "",
        lastName: formData.fullName.split(" ").slice(1).join(" ") || "",
        email: formData.email,
        organization: formData.organization,
        selectedType: formData.partnerType,
        message: formData.message,
        pageUrl: "/digital-mental-health",
      },
      {
        type: "contactus_new",
      }
    )
      .then((response) => {
        if (typeof window !== `undefined`) {
          navigate(`/thank-you-contact`);
        }
      })
      .catch((error) => {
        console.error("Form submission error:", error);
        alert("There was an error submitting the form. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector("#form-section");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToSection = (sectionId) => {
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navigateToHealthcare = (anchor) => {
    navigate(`/healthcare${anchor}`);
  };

  const partnerTypes = [
    {
      key: "01",
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      ),
      title: "Public & Private Health Systems",
      highlight: "Scale digital mental-health safely",
      description:
        "We help health systems scale digital mental-health safely and efficiently.",
      highlights: [
        "Design PHIPA-compliant digital pathways",
        "Reduce wait times through triage automation",
        "Integrate analytics to measure and prove outcomes",
      ],
      ctaText: "Explore How We Support Health Systems →",
      ctaUrl: "/healthcare#compliance",
      imageUrl:
        "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop&q=80",
      anchor: "health-systems",
    },
    {
      key: "02",
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
        </svg>
      ),
      title: "Universities & Academic Teams",
      highlight: "Translate innovation into scalable platforms",
      description:
        "We partner with academic programs to help translate innovation into scalable, compliant digital platforms.",
      highlights: [
        "Co-develop and pilot digital mental-health tools securely",
        "Build compliant infrastructure for research and ethics approval",
        "Publish measurable impact and scale successful interventions",
      ],
      ctaText: "Explore Academic Partnerships →",
      imageUrl:
        "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800&h=600&fit=crop&q=80",
      anchor: "academics",
    },
    {
      key: "03",
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      ),
      title: "Non-Profit & Advocacy Organisations",
      highlight: "Expand your mission with digital reach",
      description:
        "We help advocacy groups and NGOs to expand their mission with digital reach.",
      highlights: [
        "Digitise mental-health programs and support systems",
        "Securely manage volunteers and data",
        "Use analytics to attract new funding and partners",
      ],
      ctaText: "Partner for Social Impact →",
      imageUrl:
        "https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=800&h=600&fit=crop&q=80",
      anchor: "nonprofits",
    },
    {
      key: "04",
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
      ),
      title: "Early-Stage Digital Health Innovators",
      highlight: "Build and scale responsibly",
      description:
        "We build new digital-health solutions with innovators to accelerate and scale responsibly.",
      highlights: [
        "Build secure, scalable cloud infrastructure",
        "Access compliance, UX, and clinical expertise",
        "Create proof points that open doors to investors and pilots",
      ],
      ctaText: "See What We Can Co-Build Together →",
      ctaUrl: "/healthcare#production-and-investment",
      imageUrl:
        "https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&h=600&fit=crop&q=80",
      anchor: "innovators",
    },
  ];

  const whyPartner = [
    {
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M12 2a10 10 0 0 0 0 20 10 10 0 0 0 0-20zm0 0v20M2 12h20" />
        </svg>
      ),
      title: "Clinical + Technical DNA",
      description: "Founded by clinicians and cloud engineers",
    },
    {
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
      title: "Security by Design",
      description: "Compliant with NHS, PHIPA, and HIPAA standards",
    },
    {
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      ),
      title: "Proven Delivery",
      description: "From national systems to startup pilots",
    },
    {
      iconSvg: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
      title: "Collaboration First",
      description: "We succeed when our partners do",
    },
  ];

  return (
    <Layout
      seo={{
        title: "Digital Mental Health Solutions | digiRyte",
        ogtitle: "Building the Future of Digital Mental Health Together",
        description:
          "Partner with digiRyte to co-create digital mental health solutions that scale access, strengthen safety, and deliver measurable results. Clinical + Technical DNA for mental health impact.",
        keywords:
          "digital mental health, PHIPA compliance, HIPAA compliance, health systems, academic partnerships, mental health innovation, digital health, secure mental health platforms",
      }}
      isLandingPage={false}
      pageUrl={"/digital-mental-health"}
      redirectContactTo={"/digital-mental-health#form-section"}
      handleClick={scrollToContact}
    >
      {/* Hero Section */}
      <div className="emhic-hero">
        <div className="hero-content">
          <p className="badge-hero">digiRyte | Digital Mental Health</p>
          <h1>
            <span className="hero-title-line-1">Building the Future of</span>
            <span className="hero-title-line-2">Digital Mental Health</span>
            <span className="hero-title-line-3">Together</span>
          </h1>
          <p className="description">
            We partner with health systems, academia, advocacy groups, and
            innovators to co-create secure, scalable digital mental health
            solutions that deliver real-world impact.
          </p>
          <div className="cta-buttons">
            <button className="primary-btn" onClick={scrollToContact}>
              Start a Conversation
            </button>
          </div>
        </div>
      </div>

      {/* Intro Block */}
      <section className="intro-section">
        <div className="body-container">
          <div className="intro-content">
            <h2>
              At <span className="highlight">digiRyte</span>, we believe better
              mental health outcomes start with{" "}
              <span className="highlight">partnership</span> - not products.
            </h2>
            <p>
              We bring together clinicians, technologists, and innovators to
              co-create digital solutions that scale access, strengthen safety,
              and deliver measurable results.
            </p>
            <p className="emphasis">
              We're not here to sell. We're here to build what works - with you.
            </p>

            {/* Quick Links Navigation */}
            <div className="quick-links">
              <h3 className="quick-links-title">Quick Links</h3>
              <div className="links-grid">
                <button
                  onClick={() => scrollToSection("#health-systems")}
                  className="link-card"
                >
                  <div className="link-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                    </svg>
                  </div>
                  <div className="link-text">
                    <span className="link-label">For Health</span>
                    <span className="link-title">Systems</span>
                  </div>
                </button>
                <button
                  onClick={() => scrollToSection("#academics")}
                  className="link-card"
                >
                  <div className="link-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                    </svg>
                  </div>
                  <div className="link-text">
                    <span className="link-label">For</span>
                    <span className="link-title">Academics</span>
                  </div>
                </button>
                <button
                  onClick={() => scrollToSection("#nonprofits")}
                  className="link-card"
                >
                  <div className="link-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                    </svg>
                  </div>
                  <div className="link-text">
                    <span className="link-label">For Non-</span>
                    <span className="link-title">Profits</span>
                  </div>
                </button>
                <button
                  onClick={() => scrollToSection("#innovators")}
                  className="link-card"
                >
                  <div className="link-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M12 6v6l4 2" />
                    </svg>
                  </div>
                  <div className="link-text">
                    <span className="link-label">For</span>
                    <span className="link-title">Innovators</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Partner With Section */}
      <section className="partners-section">
        <div className="body-container">
          <div className="badge">Who We Partner With</div>
          <h1 className="headline">
            Collaboration Across the{" "}
            <span className="highlight">Mental Health Ecosystem</span>
          </h1>

          {/* Partner Types */}
          <div className="content-wrapper">
            {partnerTypes.map((partner) => (
              <div
                className="partner-item"
                key={partner.key}
                id={partner.anchor}
              >
                <div className="partner-visual">
                  <div className="visual-content">
                    <img
                      src={partner.imageUrl}
                      alt={partner.title}
                      loading="lazy"
                    />
                  </div>
                </div>
                <div className="partner-text">
                  <div className="counter-title">/ {partner.key}</div>
                  <h2>
                    <span className="icon-svg">{partner.iconSvg}</span>{" "}
                    {partner.title}
                  </h2>
                  <p className="partner-highlight">{partner.highlight}</p>
                  <p className="description">{partner.description}</p>
                  {partner.highlights && (
                    <div className="highlights-box">
                      <p className="highlights-box-title">
                        Partner with us to:
                      </p>
                      <ul>
                        {partner.highlights.map((item, idx) => (
                          <li key={idx}>
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="3"
                              style={{ marginRight: "8px", color: "#4CAF50" }}
                            >
                              <polyline points="20 6 9 17 4 12" />
                            </svg>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <button
                    className="learn-more"
                    onClick={() =>
                      partner.ctaUrl
                        ? navigate(partner.ctaUrl)
                        : scrollToContact()
                    }
                  >
                    {partner.ctaText}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Partner With Us Section */}
      <section className="why-partner-section">
        <div className="body-container">
          <div className="badge">Why Partner With Us</div>
          <h1 className="headline">
            Built for <span className="highlight">Impact</span>
          </h1>

          <div className="why-grid">
            {whyPartner.map((item, index) => (
              <div key={index} className="why-card">
                <div className="icon-large">{item.iconSvg}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Meet Our Leadership Section */}
      <section className="meet-section">
        <div className="body-container">
          <div className="meet-content">
            <div className="meet-text">
              <div className="badge">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  style={{
                    marginRight: "8px",
                    display: "inline-block",
                    verticalAlign: "middle",
                  }}
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                Leadership
              </div>
              <h1>
                Led by{" "}
                <span className="highlight">
                  Clinical & Technical Expertise
                </span>
              </h1>
              <p>
                <b>Dr. Baskar Raju</b>, ex-NHS Surgeon & CEO of digiRyte, brings
                deep clinical insight and digital transformation experience from
                leading NHS innovation initiatives.
              </p>
              <p>
                With a unique background spanning surgery, angel investing, and
                enterprise technology, Dr. Baskar understands both the clinical
                challenges and technical requirements of digital mental health
                solutions.
              </p>
              <button
                className="primary-btn"
                onClick={() => navigate("/healthcare")}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  style={{ marginRight: "8px" }}
                >
                  <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                </svg>
                Explore Healthcare Solutions
              </button>
            </div>

            <div className="meet-visual">
              <div className="profile-card">
                <div className="profile-image">
                  <img src={BaskarImage} alt="Dr. Baskar Raju" />
                </div>
                <div className="profile-info">
                  <h3>Dr. Baskar Raju</h3>
                  <p className="role">CEO & MD, digiRyte</p>
                  <p className="bio">
                    Surgeon-Turned Tech CEO | Angel Investor | Ex-NHS Digital
                    Innovation Lead
                  </p>
                  <a
                    href="https://calendly.com/baskar-digiryte/30min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="book-btn"
                  >
                    Book a Call
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-section" id="form-section">
        <div className="body-container">
          <div className="contact-badge">Get in Touch</div>

          <h1 className="headline">
            Let's Build <span className="highlight">Together</span>
          </h1>

          {/* <!-- Calendly inline widget begin --> */}
          <InlineWidget url="https://calendly.com/baskar-digiryte/30min" />
          {/* <!-- Calendly inline widget end --> */}
        </div>
      </section>
      {/* Footer Quote Section */}
      <section className="quote-section">
        <div className="body-container">
          <div className="quote-content">
            <div className="decorative-circles">
              <div className="circle circle-1"></div>
              <div className="circle circle-2"></div>
              <div className="circle circle-3"></div>
            </div>
            <h1 className="quote-text">
              Partnership
              <br />
              Not Products
            </h1>
            <p className="quote-author">
              digiRyte | Clinical + Technical DNA | Built for Mental Health
              Impact
            </p>
            <p className="quote-author" style={{ marginTop: "1rem" }}>
              <a
                href="https://www.digiryte.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "white", textDecoration: "underline" }}
              >
                www.digiryte.com
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Floating Contact Buttons */}
      <a href="tel:+447725030242" className="phone-float" aria-label="Call Us">
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          className="phone-icon"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
        </svg>
      </a>

      <a
        href="https://wa.me/447725030242?text=Hi, I'm interested in learning more about digiRyte's digital mental health solutions"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          className="whatsapp-icon"
        >
          <path
            fill="currentColor"
            d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-4.713 1.262 1.262-4.669-0.292-0.508c-1.207-2.100-1.847-4.507-1.847-6.924 0-7.435 6.052-13.487 13.487-13.487s13.487 6.052 13.487 13.487c0 7.435-6.052 13.487-13.487 13.487zM21.713 18.5c-0.297-0.149-1.757-0.868-2.030-0.967-0.272-0.099-0.47-0.149-0.669 0.148s-0.769 0.967-0.943 1.165c-0.173 0.198-0.347 0.223-0.644 0.074-0.297-0.149-1.255-0.462-2.39-1.475-0.883-0.788-1.48-1.761-1.653-2.059s-0.018-0.458 0.13-0.606c0.134-0.133 0.297-0.347 0.446-0.521s0.198-0.297 0.297-0.495c0.099-0.198 0.050-0.372-0.025-0.521s-0.669-1.611-0.916-2.206c-0.242-0.579-0.487-0.501-0.669-0.51-0.173-0.008-0.372-0.010-0.571-0.010s-0.52 0.074-0.793 0.372c-0.272 0.297-1.040 1.016-1.040 2.479s1.065 2.876 1.213 3.074c0.149 0.198 2.095 3.2 5.076 4.487 0.709 0.306 1.263 0.489 1.694 0.626 0.712 0.226 1.36 0.194 1.872 0.118 0.571-0.085 1.758-0.719 2.006-1.413s0.248-1.289 0.173-1.413c-0.074-0.124-0.272-0.198-0.57-0.347z"
          />
        </svg>
      </a>

      {/* <LPFooter ctaClick={scrollToContact} /> */}
    </Layout>
  );
}

export default DigitalMentalHealth;
